"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveIndicatorTemplate = void 0;
var tslib_1 = require("tslib");
var live_indicator_dot_1 = (0, tslib_1.__importDefault)(require("./live-indicator.dot"));
var liveIndicatorTemplate = live_indicator_dot_1.default.default ? live_indicator_dot_1.default.default : live_indicator_dot_1.default;
exports.liveIndicatorTemplate = liveIndicatorTemplate;
//# sourceMappingURL=index.js.map